module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<script async defer src="https://www.google.com/recaptcha/api.js?render=<?php echo $RECAPTCHA_KEY; ?>" id="recaptcha-page-script"></script>\n';

}
return __p
}